import { HttpClient, HttpHeaders } from '@angular/common/http';
import {environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { EncrDecrService } from '../../services/encr-decr.service';

@Injectable({
  providedIn: 'root'
})
export class AdsService {

  constructor(private http: HttpClient,
    private EncDecrService: EncrDecrService) { }

    getAllAds(country){
      return this.http.post(environment.apiURI + 'ads/all', {country: country}).toPromise();
    }

    createAd(data){
      const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
      var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
      return this.http.post(environment.apiURI + 'ads/create', data, { headers: headers_object }).toPromise();
    }

    activateAd(id){
      const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
      var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
      return this.http.get(environment.apiURI + 'ads/activate/'+id, { headers: headers_object }).toPromise();
    }

    deleteAd(id){
      const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
      var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
      return this.http.get(environment.apiURI + 'ads/delete/'+id, { headers: headers_object }).toPromise();
    }

    updateAd(id, data){
      const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
      var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
      return this.http.post(environment.apiURI + 'ads/update/'+id ,data, { headers: headers_object }).toPromise();
    }

    getAllAdsUser(){
      
      return this.http.get(environment.apiURI + 'ads').toPromise();
    }

    deleteAdUser(id){
      const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
      var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
      return this.http.delete(environment.apiURI + 'user/ads/'+id, { headers: headers_object }).toPromise();
    }
}
